import { Box, Chip, Grid, Typography } from '@mui/material';
import { formatMoney } from 'shared/utility';
import { getStatusColumnColor } from 'shared/utility/dataGrid';
import { ApprovalDashboardData } from 'types/backend';

export function AnalyticsDrawerHeader({ analyticsDrawerRow }: { analyticsDrawerRow: ApprovalDashboardData }) {
    const drawerTitle = [
        analyticsDrawerRow?.customerName,
        analyticsDrawerRow?.endUser || analyticsDrawerRow?.priceGroup,
        analyticsDrawerRow?.productId,
    ]
        .filter(Boolean)
        .join(' | ');
    return (
        <Grid
            container
            sx={{
                p: '0.5rem 1.5rem',
                backgroundColor: 'lightgray',
            }}
            justifyContent={'center'}
            alignItems={'center'}
        >
            <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Typography sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} variant='body1'>
                    {drawerTitle}
                </Typography>
                <Typography sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }} variant='body2'>
                    {drawerTitle}
                </Typography>
            </Grid>
            <Grid
                item
                md={6}
                sx={{
                    display: { xs: 'none', sm: 'none', md: 'block' },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        gap: 2,
                        flexWrap: 'wrap',
                    }}
                >
                    <Chip
                        label={`Target: ${formatMoney(analyticsDrawerRow?.targetPrice)}`}
                        variant='outlined'
                        color='primary'
                    />
                    <Chip
                        label={`Current: ${formatMoney(analyticsDrawerRow?.currentPrice)}`}
                        variant='outlined'
                        color='primary'
                    />
                    <Chip
                        label={`Requested: ${formatMoney(analyticsDrawerRow?.requestedPrice)}`}
                        variant='outlined'
                        color='primary'
                    />
                    <Chip
                        label={analyticsDrawerRow?.status}
                        color={getStatusColumnColor(analyticsDrawerRow?.status)}
                        variant='outlined'
                    />
                </Box>
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                gap={2}
                sx={{ display: { xs: 'flex', sm: 'flex', md: 'none', justifyContent: 'space-between' } }}
            >
                <Typography color='primary' variant='body2'>
                    Target: {formatMoney(analyticsDrawerRow?.targetPrice)}
                </Typography>
                <Typography color='primary' variant='body2'>
                    Current: {formatMoney(analyticsDrawerRow?.currentPrice)}
                </Typography>
                <Typography color='primary' variant='body2'>
                    Requested: {formatMoney(analyticsDrawerRow?.requestedPrice)}
                </Typography>
                <Typography color={getStatusColumnColor(analyticsDrawerRow?.status)} variant='body2'>
                    {analyticsDrawerRow?.status}
                </Typography>
            </Grid>
        </Grid>
    );
}
